import { HttpResponse } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { Transaction } from '@kr/models';

import { ChunkEstimatesAndRiskScoreReq, DownloadCsvReq, MassPayOut } from '../models';

export interface MassPayOutApi {
  getEstimatesAndRiskScores(body: ChunkEstimatesAndRiskScoreReq, walletId: string, orgId: number): Observable<MassPayOut>;
  executeMassPayout(body: MassPayOut, walletId: string, orgId: number): Observable<Transaction[]>;
  downloadCsv(params: DownloadCsvReq, orgId: number): Observable<HttpResponse<Blob>>;
}

export const MASS_PAYOUT_API = new InjectionToken<MassPayOutApi>('MASS_PAYOUT_API ');
